// @flow
export function isUndefOrNull(value: any): boolean {
  return (typeof value === 'undefined') || value === null;
}

export default isUndefOrNull;
